import { useTranslation } from '@nucleus-commerce/i18n/react';
import { Button } from '@nucleus-commerce/ui/components/button';
import { cn } from '@nucleus-commerce/ui/lib/utils';

import { tourTitleKey } from '../registry';
import { useTour } from '../tour-context';

/** Shown after the person navigated away mid-tour: resume where they were, or end it. */
export function PausedPill() {
  const tour = useTour();
  const { t } = useTranslation('common');
  const { t: tt } = useTranslation(tour.namespace);
  if (!tour.state.tourId) return null;
  return (
    <div
      role="region"
      aria-label={t('tour.pausedLabel')}
      className={cn(
        'bg-card text-card-foreground fixed right-4 bottom-4 z-[70] flex items-center gap-3 rounded-full border py-1.5 pr-1.5 pl-4 text-sm shadow-lg',
        !tour.reducedMotion &&
          'animate-in fade-in-0 slide-in-from-bottom-4 motion-reduce:slide-in-from-bottom-0 duration-200',
      )}
    >
      <span>{t('tour.paused', { title: tt(tourTitleKey(tour.state.tourId), tour.values) })}</span>
      <Button size="sm" className="rounded-full" onClick={tour.resume}>
        {t('tour.resume')}
      </Button>
      <Button
        size="sm"
        variant="ghost"
        className="rounded-full"
        onClick={() => tour.end('paused-end')}
      >
        {t('tour.endShort')}
      </Button>
    </div>
  );
}
